import { endPoints, requestType } from "../../constants/Variables";
import Api from "../index";

const getSubscriptionHistoryByUserId = (id) => {
  return Api(
    `${endPoints.getSubscriptionHistoryByUserId}/${id}`,
    null,
    requestType.GET
  );
};

const createSubscriptionHistory = (params) => {
  return Api(endPoints.createSubscriptionHistory, params, requestType.POST);
};

export { getSubscriptionHistoryByUserId, createSubscriptionHistory };
